<template>
    <div class="flex flex-col">
        <div class="flex justify-center items-center my-8">
            <hr class="w-full flex-1 border-gray-300">
            <p class="mx-4 text-sm font-regular uppercase text-gray-500">
                {{ date }}
            </p>
            <hr class="w-full flex-1 border-gray-300">
        </div>

        <div class="space-y-2 | lg:px-4">
            <conversation-message-list-item
                :inactive="inactive"
                :message="message"
                :show-time="index !== 0 && isDifferentGroup(messages[index - 1], message)"
                :key="message.id"
                v-for="(message, index) in messages"
            />
        </div>
    </div>
</template>

<script>
    import ConversationMessageListItem from '@/views/Chat/ConversationMessageListItem.vue';

    export default {
        components: {
            ConversationMessageListItem,
        },

        props: {
            messages: {
                type: Array,
                required: true,
            },
            inactive: {
                type: Boolean,
                required: true,
            },
        },

        computed: {
            date() {
                return this.formatCustomDate(this.messages[0].created_at);
            },
        },

        methods: {
            formatCustomDate(date) {
                const momentDate = moment(date);
                const momentNow = moment();
                let dateString = momentDate.format('D MMM');

                if (momentDate.startOf('day').isSame(momentNow.startOf('day'))) {
                    dateString = this.$t('global.date.today');
                } if (momentDate.startOf('day').isSame(momentNow.subtract(1, 'days').startOf('day'))) {
                    dateString = this.$t('global.date.yesterday');
                }

                return `${dateString} ${this.formatTime(date)}`;
            },

            isDifferentGroup(message1, message2) {
                if (moment(message1.created_at) < moment(message2.created_at).subtract(5, 'minutes')) {
                    return true;
                }

                return false;
            },
        },
    };
</script>
